import { render, staticRenderFns } from "./DimensionSelection.vue?vue&type=template&id=78831c3c&scoped=true"
import script from "./DimensionSelection.vue?vue&type=script&lang=js"
export * from "./DimensionSelection.vue?vue&type=script&lang=js"
import style0 from "./DimensionSelection.vue?vue&type=style&index=0&id=78831c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78831c3c",
  null
  
)

export default component.exports